/**
 * SMS consent copy helpers for form builder and public form rendering.
 */

export const DEFAULT_SMS_CONSENT_TEXT =
  'By providing your phone number and checking this box, you agree to receive text messages from {businessName} to follow up on your inquiry and help schedule appointments. Consent is optional and not a condition of purchase. Message frequency varies. Message and data rates may apply. Reply STOP to opt out, HELP for help. See our Privacy Policy and Terms. Message may be sent using automated technology. Checking the box is your electronic signature and agreement to these terms.';

export const PRIVACY_POLICY_URL = 'https://gocta.ai/privacy';
export const TERMS_URL = 'https://gocta.ai/terms';

/**
 * Resolve a display name for consent copy.
 * Falls back to form name, then "us".
 */
export function resolveConsentBusinessName({ businessName, formName } = {}) {
  const trimmed = (businessName || '').trim();
  if (trimmed) return trimmed;
  const formTrimmed = (formName || '').trim();
  if (formTrimmed) return formTrimmed;
  return 'us';
}

export function buildConsentText({ businessName, formName, template } = {}) {
  const name = resolveConsentBusinessName({ businessName, formName });
  const text = template || DEFAULT_SMS_CONSENT_TEXT;
  return text.replace(/\{businessName\}/g, name);
}

/**
 * Split consent text into plain segments and link placeholders for Privacy Policy / Terms.
 */
export function parseConsentTextWithLinks(consentText) {
  const parts = [];
  const regex = /(Privacy Policy|Terms)/g;
  let lastIndex = 0;
  let match;
  while ((match = regex.exec(consentText)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', value: consentText.slice(lastIndex, match.index) });
    }
    parts.push({
      type: 'link',
      value: match[1],
      href: match[1] === 'Privacy Policy' ? PRIVACY_POLICY_URL : TERMS_URL,
    });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < consentText.length) {
    parts.push({ type: 'text', value: consentText.slice(lastIndex) });
  }
  return parts;
}
